import React from 'react';
import Api from '../../Api.js';
import { ModalContainer, ModalDialog } from 'react-modal-dialog';

class G2CopyPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      custs: [],
      srclocs: [],
      orgs: [],
      dstlocs: [],
      showModal: false,
      showErrorModal: false,
      errorMsg: '',
      cust: '',
      srcloc: '',
      org: '',
      dstloc: '',
      itemcnt: 0,
      useinv: false,
      runningScript: false,
    };
  }

  componentDidMount() {
    Api.getSHQCusts().then((data) => {
      let custList = data.customers || [];
      custList.sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1));
      this.setState({ custs: custList, cust: custList[0] });

      Api.getSHQLocs(custList[0].id)
        .then((data) => {
          let srclocList = data.locations || [];
          this.setState({ srclocs: srclocList, srcloc: srclocList[0] });
        })
        .catch(() => {
          this.handleShowError('Unable to fetch location list from SHQ');
        });
    });

    Api.getOrgList().then((data) => {
      let orgList = data || [];
      this.setState({ orgs: orgList, org: orgList[0] });

      Api.getLocationList(orgList[0].id)
        .then((data) => {
          let dstlocList = data || [];
          this.setState({ dstlocs: dstlocList, dstloc: dstlocList[0] });
        })
        .catch(() => {
          this.handleShowError('Unable to fetch location list from dashapi');
        });
    });
  }

  goToCopyHistory() {
    this.props.handleSelect(5);
  }

  getSHQLocs(custId) {
    Api.getSHQLocs(custId).then((data) => {
      let srclocList = data.serialnumber || '';
      this.setState({ srclocs: srclocList, srcloc: srclocList[0] });
    });
  }

  handleCustChange(e) {
    let value = e.target.value;
    let filter = this.state.custs.filter((cust) => {
      return cust.id == value;
    });
    let cust = filter[0];
    this.setState({ cust: cust });
    Api.getSHQLocs(cust.id)
      .then((data) => {
        let srclocList = data.locations || [];
        this.setState({ srclocs: srclocList, srcloc: srclocList[0] });

        if (srclocList.length <= 0) {
          this.handleShowError('This cust has no locations');
        }
      })
      .catch(() => {
        this.handleShowError('Unable to fetch location list from SHQ');
      });
  }

  handleSrcLocChange(e) {
    let value = e.target.value;
    let filter = this.state.srclocs.filter((srcloc) => {
      return srcloc.id == value;
    });
    let srcloc = filter[0];
    this.setState({ srcloc: srcloc });
  }

  handleOrgChange(e) {
    let value = e.target.value;
    let filter = this.state.orgs.filter((org) => {
      return org.id == value;
    });
    let org = filter[0];
    this.setState({ org: org });
    Api.getLocationList(org.id)
      .then((data) => {
        let dstlocList = data || [];
        this.setState({ dstlocs: dstlocList, dstloc: dstlocList[0] });

        if (dstlocList.length <= 0) {
          this.handleShowError('This org has no locations');
        }
      })
      .catch(() => {
        this.handleShowError('Unable to fetch location list from ADM');
      });
  }

  handleDstLocChange(e) {
    let value = e.target.value;
    let filter = this.state.dstlocs.filter((dstloc) => {
      return dstloc.id == value;
    });
    let dstloc = filter[0];
    this.setState({ dstloc: dstloc });
  }

  handleIncInvChange(e) {
    let tgt = e.target;
    let value = tgt.type === 'checkbox' ? tgt.checked : false;
    this.setState({ useinv: value });
  }

  handleCloseError() {
    this.setState({
      showErrorModal: false,
      errorMsg: '',
    });
  }

  handleShowError(msg) {
    this.setState({
      showErrorModal: true,
      errorMsg: msg,
    });
  }

  handleCloseModal() {
    this.setState({
      showModal: false,
    });
  }

  handleShowModal() {
    Api.getItemCount(this.state.srcloc.id)
      .then((data) => {
        let cnt = data.itemcount || [];
        this.setState({ itemcnt: cnt, showModal: true });
      })
      .catch(() => {
        this.handleShowError('Unable to get item count for Source Location');
      });
  }

  handleSubmit() {
    this.handleCloseModal();
    Api.copyProducts(this.state.srcloc.id, this.state.dstloc.id, this.state.useinv).catch((e) => {
      this.handleShowError(e.message);
    });
    this.setState({ runningScript: true });
  }

  render() {
    return (
      <div className='content'>
        <div className='pure-form pure-form-horizontal pure-g'>
          <div className='pure-u-1'>
            <div className='pure-u-1-5'></div>
            <div className='pure-u-1-5'>
              <div className='pure-control-group pure-u-1'>
                <label className='pure-u-1' style={{ color: 'gray' }}>
                  Customer Name
                </label>
                <select
                  id='srccustomer'
                  className='pure-input-1'
                  style={{ height: '3.6em' }}
                  onChange={this.handleCustChange.bind(this)}
                >
                  {this.state.custs.map((cust) => (
                    <option key={cust.id} value={cust.id}>
                      {cust.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className='pure-u-1-5'></div>
            <div className='pure-u-1-5'>
              <div className='pure-control-group'>
                <label className='pure-u-1' style={{ color: 'gray' }}>
                  Org Name
                </label>
                <select
                  id='srcorg'
                  className='pure-input-1'
                  style={{ height: '3.6em' }}
                  onChange={this.handleOrgChange.bind(this)}
                >
                  {this.state.orgs.map((org) => (
                    <option key={org.id} value={org.id}>
                      {org.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className='pure-u-1-5'></div>
          </div>
        </div>

        <div className='pure-form pure-form-horizontal pure-g'>
          <div className='pure-u-1'>
            <div className='pure-u-1-5'></div>
            <div className='pure-u-1-5'>
              <div className='pure-control-group pure-u-1'>
                <label className='pure-u-1' style={{ color: 'gray' }}>
                  Source Location Name
                </label>
                <select
                  id='srclocation'
                  className='pure-input-1'
                  style={{ height: '3.6em' }}
                  onChange={this.handleSrcLocChange.bind(this)}
                >
                  {this.state.srclocs.map((srcloc) => (
                    <option key={srcloc.id} value={srcloc.id}>
                      {srcloc.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className='pure-u-1-5'></div>
            <div className='pure-u-1-5'>
              <div className='pure-control-group pure-u-1'>
                <label className='pure-u-1' style={{ color: 'gray' }}>
                  Destination Location Name
                </label>
                <select
                  id='dstlocation'
                  className='pure-input-1'
                  style={{ height: '3.6em' }}
                  onChange={this.handleDstLocChange.bind(this)}
                >
                  {this.state.dstlocs.map((dstloc) => (
                    <option key={dstloc.id} value={dstloc.id}>
                      {dstloc.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className='pure-u-1-5'></div>
          </div>
        </div>

        <div className='pure-form pure-form-horizontal pure-g'>
          <div className='pure-u-1'>
            <div className='pure-u-1-5'></div>
            <div className='pure-u-1-5'>
              <div className='pure-control-group pure-u-1'>
                <label style={{ color: 'gray' }} className='pure-checkbox'>
                  <input
                    type='checkbox'
                    id='useinv'
                    defaultValue=''
                    onClick={this.handleIncInvChange.bind(this)}
                  />{' '}
                  Include Current Inventory Levels?
                </label>
              </div>
            </div>
            <div className='pure-u-1-5'></div>
            <div className='pure-u-1-5'></div>
            <div className='pure-u-1-5'></div>
          </div>
        </div>

        <div className='pure-form pure-form-horizontal pure-g'>
          <div className='pure-control-group pure-u-1'>
            <div className='pure-u-1-4'></div>
            <button
              onClick={this.handleShowModal.bind(this)}
              style={{ marginTop: '1%', height: '3.6em' }}
              className='pure-button pure-button-primary pure-u-1-2'
            >
              Copy Products
            </button>
            <div className='pure-u-1-4'></div>
          </div>
        </div>
        {this.state.runningScript ? (
          <div
            ref='running-script'
            className='pure-control-group pure-u-1'
            style={{ marginTop: '30px' }}
          >
            <div className='pure-u-1-4'></div>
            <div className=' pure-u-1-2' style={{ marginTop: '40px' }}>
              <button
                className='pure-button pure-button-primary pure-u-1'
                style={{ height: '3.6em' }}
                onClick={this.goToCopyHistory.bind(this)}
              >
                VIEW HISTORY RESULTS
              </button>
            </div>
            <div className='pure-u-1-4'></div>
          </div>
        ) : (
          <div />
        )}

        {this.state.showModal && (
          <ModalContainer>
            <ModalDialog>
              <div>
                <i
                  className='fa fa-exclamation-circle danger'
                  style={{ textAlign: 'center', fontSize: '50px', display: 'block' }}
                ></i>
              </div>
              <h1>
                Please Confirm Your Selections
                <br />
                This cannot be undone
              </h1>
              <ul>
                <li>
                  <h3 style={{ textAlign: 'left' }}>
                    Source Customer: <span style={{ color: 'red' }}>{this.state.cust.name}</span>
                  </h3>
                </li>
                <li>
                  <h3 style={{ textAlign: 'left' }}>
                    Source Location: <span style={{ color: 'red' }}>{this.state.srcloc.name}</span>
                  </h3>
                </li>
                <li>
                  <h3 style={{ textAlign: 'left' }}>
                    Target Org: <span style={{ color: 'red' }}>{this.state.org.name}</span>
                  </h3>
                </li>
                <li>
                  <h3 style={{ textAlign: 'left' }}>
                    Target Location: <span style={{ color: 'red' }}>{this.state.dstloc.name}</span>
                  </h3>
                </li>
                <li>
                  <h3 style={{ textAlign: 'left' }}>
                    Include Inventory:{' '}
                    <span style={{ color: 'red' }}>{this.state.useinv ? 'Yes' : 'No'}</span>
                  </h3>
                </li>
                <li>
                  <h3 style={{ textAlign: 'left' }}>
                    Total Products to Copy:{' '}
                    <span style={{ color: 'red' }}>{this.state.itemcnt}</span>
                  </h3>
                </li>
              </ul>
              <button className='pure-button pure-u-1-2' onClick={this.handleCloseModal.bind(this)}>
                Cancel
              </button>
              <button
                className='pure-button pure-button-primary pure-u-1-2'
                onClick={this.handleSubmit.bind(this)}
              >
                Copy Products
              </button>
            </ModalDialog>
          </ModalContainer>
        )}
        {this.state.showErrorModal && (
          <ModalContainer onClose={this.handleCloseError.bind(this)}>
            <ModalDialog>
              <h2>
                <i className='fa fa-exclamation-circle danger'></i> Error
              </h2>
              <div>{this.state.errorMsg}</div>
            </ModalDialog>
          </ModalContainer>
        )}
      </div>
    );
  }
}

export default G2CopyPage;



// WEBPACK FOOTER //
// ./src/components/pages/G2CopyPage.js